import Header from "../header/header";
import Footer from "../footer/footer";
import NavBar from "../nav/nav-bar";
import ReportNav from "./report-nav";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { faCommentsDollar } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import Service from "./../webservice/http";
import { useHistory } from "react-router-dom";
import { storage } from "../utils/storage";

const CustomerIntentReportAll = () => {
  const history = useHistory();
  const services = new Service();

  const [showRealData, setShowRealData] = useState(true);

  const [customerData, setCustomerData] = useState("");

  const [dateDifference, setDateDifference] = useState("");

  const [displayDateCategory, setDisplayDateCategory] = useState(null);

  /**
   * Fetch Customer intent report data
   */

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    const today = new Date();
    const endDate = new Date(today);
    endDate.setDate(today.getDate() - dateDifference);

    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    if (dateDifference) {
      setEndDate(formatDate(endDate));
      setStartDate(formatDate(today));
    } else {
      setEndDate("");
      setStartDate("");
    }
  }, [dateDifference]);

  useEffect(() => {
    if (startDate && endDate) {
      fetchData();
    }
  }, [startDate, endDate]);

  async function fetchData() {
    let url = "api/report/customer_intent/";

    if (startDate && endDate) {
      url = url + `?from_date=${endDate}&to_date=${startDate}`;
    }

    const res = await services.get(url).then((res) => {
      if (res === "TypeError: Failed to fetch") {
        console.error("Connection Error");
      } else {
        try {
          if (res.code === "token_not_valid") {
            storage.clear();
            history.push("/login");
          }
          console.log("API Response:", res);
          setCustomerData(res);
          const aggregatedIntent = res?.aggregated_intent || {};
          const customerIntentArray = Object.entries(aggregatedIntent).map(
            ([key, value]) => [key, value],
          );
          setCustomerIntentData(customerIntentArray);
          const productDistribution = res?.product_distribution || {};
          const callDistributionArray = Object.entries(productDistribution).map(
            ([key, value]) => [key, value],
          );
          setCallDistributionData(callDistributionArray);
        } catch (e) {
          console.error(e);
        }
      }
    });
  }

  const [customerIntentData, setCustomerIntentData] = useState([]);

  const [callDistributionData, setCallDistributionData] = useState([]);

  const [aggregatedCustomerIntentData, setAggregatedCustomerIntentData] =
    useState([]);

  const [managerCommentData, setManagerCommentData] = useState({
    count: 0,
    change: 0,
  });

  const [opportunityData, setOpportunityData] = useState({
    count: 0,
    change: 0,
  });

  const [serviceRequestData, setServiceRequestData] = useState({
    count: 0,
    change: 0,
  });

  const [activeFilter, setActiveFilter] = useState("7");

  /**
   * Customer intent chart config
   */
  const callDistributionOptions = {
    chart: {
      type: "pie",
      height: "250px",
      marginBottom: 70,
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "{point.percentage:.1f} %",
          distance: -20,
        },
        showInLegend: true,
        size: "120%",
      },
    },
    legend: {
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      y: 0,
      padding: 10,
    },
    series: [
      {
        name: "Delivered amount",
        data: callDistributionData,
      },
    ],
  };

  const customerIntentOptions = {
    chart: {
      type: "pie",
      height: "250px",
      marginBottom: 70,
    },
    title: {
      text: "Intent",
      align: "center",
      verticalAlign: "middle",
      y: -9,
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "{point.percentage:.1f} %",
          distance: -20,
        },
        showInLegend: true,
        size: "120%",
        innerSize: "50%",
      },
    },
    legend: {
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      y: 0,
      padding: 10,
    },
    series: [
      {
        name: "Delivered amount",
        data: customerIntentData,
      },
    ],
  };
  /**
   * aggregated customer intent bar chart config
   */
  const aggregatedCustomerIntentOptions = {
    chart: {
      type: "column",
      height: (3 / 19) * 100 + "%",
    },

    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      gridLineWidth: 0,
      categories: displayDateCategory,
    },
    yAxis: {
      // gridLineWidth: 0,
      gridLineColor: "transparent",
    },
    yAxis: [
      {
        className: "highcharts-color-0",
        title: {
          text: "Positive Intent",
        },
      },
      {
        className: "highcharts-color-1",
        opposite: true,
        title: {
          text: "Negative Intent",
        },
      },
    ],

    plotOptions: {
      column: {
        borderRadius: 5,
      },
    },

    series: [
      {
        data: aggregatedCustomerIntentData[0],
        name: "Positive",
      },
      {
        data: aggregatedCustomerIntentData[1],
        name: "Negative",
        yAxis: 1,
      },
    ],
  };

  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);

  /**
   * Change Report interval
   * @param {*} e Event
   */
  const handleFilterClick = (filter) => {
    if (filter === "clear") {
      setActiveFilter(null);
      setDateDifference("");
      setEndDate("");
      setStartDate("");
    } else {
      setActiveFilter(filter);
      setDateDifference(filter);
    }
  };

  return (
    <div className="dashboard-body">
      <Header />
      <NavBar />

      <div>
        <div className="container-fluid">
          <div className="my-call">
            <div
              className="side-panel-with-table clearfix"
              style={{ display: "flex" }}
            >
              <ReportNav />

              <div className="call-table">
                <div className="my-calls-column">
                  <div className="calls-top-pannel">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="pannel-heading clearfix">
                          <div className="pannel-heading-icon">
                            <i class="fa fa-tachometer" aria-hidden="true"></i>
                          </div>
                          <div className="pannel-heading-info">
                            {storage.getItem("usecase") ===
                            "Complaints Management" ? (
                              <h3>Intent Trends </h3>
                            ) : (
                              <h3>Customer Intent </h3>
                            )}
                            {storage.getItem("usecase") ===
                            "Complaints Management" ? (
                              <p>
                                Track the overall Complaints Intent Trends over
                                time
                              </p>
                            ) : (
                              <p>
                                Track the overall Customer Intent and the impact
                                of CX Score over time
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="pannel-nav clearfix">
                          <ul className="clearfix">
                            <div
                              className="btn-group btn-group-toggle"
                              data-toggle="buttons"
                            >
                              <label
                                className={`btn btn-default ${
                                  activeFilter === "7" ? "active" : ""
                                }`}
                                id="7"
                                onClick={() => handleFilterClick("7")}
                              >
                                <input
                                  type="radio"
                                  name="options"
                                  autoComplete="off"
                                  style={{ outline: "none" }}
                                />{" "}
                                7 Days
                              </label>
                              <label
                                className={`btn btn-default ${
                                  activeFilter === "30" ? "active" : ""
                                }`}
                                id="30"
                                onClick={() => handleFilterClick("30")}
                              >
                                <input
                                  type="radio"
                                  name="options"
                                  autoComplete="off"
                                  style={{ outline: "none" }}
                                />{" "}
                                30 Days{" "}
                              </label>
                              <label
                                className={`btn btn-default ${
                                  activeFilter === "90" ? "active" : ""
                                }`}
                                id="90"
                                onClick={() => handleFilterClick("90")}
                              >
                                <input
                                  type="radio"
                                  name="options"
                                  autoComplete="off"
                                  style={{ outline: "none" }}
                                />{" "}
                                90 Days
                              </label>
                            </div>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex justify-between">
                  <div
                    className="w-1/3"
                    style={{ paddingBottom: "5px", width: "35%" }}
                  >
                    <div className="all-list" style={{ height: "310px" }}>
                      <label>Customer Intent</label>
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={customerIntentOptions}
                      />
                    </div>
                  </div>

                  <div
                    className="w-1/3"
                    style={{ paddingBottom: "5px", width: "35%" }}
                  >
                    <div className="all-list" style={{ height: "310px" }}>
                      {storage.getItem("usecase") ===
                      "Complaints Management" ? (
                        <label>Ticket Distribution (by Product)</label>
                      ) : (
                        <label>Call Distribution (by Product)</label>
                      )}
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={callDistributionOptions}
                      />
                    </div>
                  </div>

                  <div
                    className=""
                    style={{ paddingBottom: "5px", width: "28%" }}
                  >
                    <div
                      className=""
                      style={{ paddingBottom: "5px", marginBottom: "7px" }}
                    >
                      <div className="all-list" style={{ height: "95px" }}>
                        <div className="pannel-heading-icon">
                          <i className="fa fa-comment" aria-hidden="true" />
                        </div>
                        <div className="row">
                          <div
                            className="col-md-6"
                            style={{ textAlign: "center" }}
                          >
                            <a style={{ fontSize: "30px" }}>
                              {customerData?.manager_comments?.count}
                            </a>
                            <br />
                            <label>Manager Comment</label>
                          </div>
                          <div
                            className="col-md-4"
                            style={{ textAlign: "center" }}
                          >
                            {customerData?.manager_comments
                              ?.percentage_change >= 0 && (
                              <a style={{ fontSize: "25px", color: "green" }}>
                                {" "}
                                {
                                  customerData?.manager_comments
                                    ?.percentage_change
                                }
                                %{" "}
                                <i
                                  className="fa fa-arrow-up"
                                  aria-hidden="true"
                                />
                              </a>
                            )}
                            {customerData?.manager_comments?.percentage_change <
                              0 && (
                              <a style={{ fontSize: "25px", color: "red" }}>
                                {" "}
                                {managerCommentData["change"]}%{" "}
                                <i
                                  className="fa fa-arrow-down"
                                  aria-hidden="true"
                                />
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {storage.getItem("usecase") === "Complaints Management" ? (
                      ""
                    ) : (
                      <div
                        className=""
                        style={{ paddingBottom: "5px", marginBottom: "7px" }}
                      >
                        <div className="all-list" style={{ height: "95px" }}>
                          <div className="pannel-heading-icon">
                            <i className="fa fa-users" aria-hidden="true" />
                          </div>

                          <div className="row">
                            <div
                              className="col-md-6"
                              style={{ textAlign: "center" }}
                            >
                              <a style={{ fontSize: "30px" }}>
                                {customerData?.opportunities?.count}
                              </a>
                              <br />
                              <label>Opportunity</label>
                            </div>
                            <div
                              className="col-md-4"
                              style={{ textAlign: "center" }}
                            >
                              {customerData?.opportunities?.percentage_change >=
                                0 && (
                                <a style={{ fontSize: "25px", color: "green" }}>
                                  {" "}
                                  {
                                    customerData?.opportunities
                                      ?.percentage_change
                                  }
                                  %{" "}
                                  <i
                                    className="fa fa-arrow-up"
                                    aria-hidden="true"
                                  />
                                </a>
                              )}

                              {customerData?.opportunities?.percentage_change <
                                0 && (
                                <a style={{ fontSize: "25px", color: "red" }}>
                                  {" "}
                                  {opportunityData["change"]}%{" "}
                                  <i
                                    className="fa fa-arrow-down"
                                    aria-hidden="true"
                                  />
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div
                      className=""
                      style={{ paddingBottom: "5px", marginBottom: "7px" }}
                    >
                      <div className="all-list" style={{ height: "95px" }}>
                        <div className="pannel-heading-icon">
                          <i className="fa fa-cog" aria-hidden="true" />
                        </div>
                        <div className="row">
                          <div
                            className="col-md-6"
                            style={{ textAlign: "center" }}
                          >
                            <a style={{ fontSize: "30px" }}>
                              {customerData?.service_requests?.count}
                            </a>
                            <br />
                            <label>Service Request</label>
                          </div>
                          <div
                            className="col-md-4"
                            style={{ textAlign: "center" }}
                          >
                            {customerData?.service_requests
                              ?.percentage_change >= 0 && (
                              <a style={{ fontSize: "25px", color: "green" }}>
                                {" "}
                                {
                                  customerData?.service_requests
                                    ?.percentage_change
                                }
                                %{" "}
                                <i
                                  className="fa fa-arrow-up"
                                  aria-hidden="true"
                                />
                              </a>
                            )}
                            {customerData?.service_requests?.percentage_change <
                              0 && (
                              <a style={{ fontSize: "25px", color: "red" }}>
                                {" "}
                                {serviceRequestData["change"]}%{" "}
                                <i
                                  className="fa fa-arrow-down"
                                  aria-hidden="true"
                                />
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div
                    className="col-lg-12 col-md-12"
                    // style={{ paddingBottom: "25px" }}
                  >
                    <div className="all-list">
                      <label>Aggregated Customer Intent Trend</label>
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={aggregatedCustomerIntentOptions}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CustomerIntentReportAll;
